import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router';
import { userContext } from '../../../App';

const PrivateRoute = ({children, ...rest}) => {
    const [loggedInUser] = useContext(userContext);
    return (
        <div>
            <Route
                {...rest}
                render={props =>
                    loggedInUser?.CustomerEmail ? (
                        children
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: { from: props.location }
                            }}
                        />
                    )
                }
            />
        </div>
    );
};

export default PrivateRoute;